import React from "react";
import {UseMainLayout} from "../../context/LayoutContext";
import LeftSideBar01 from "./LeftSideBar01";

type SettingsLayoutProps = {
    children: React.ReactNode;
};

export function SettingsLayout({children}: SettingsLayoutProps) {
    UseMainLayout();

    return (
        <>
            <LeftSideBar01/>
            <div className="col-md-10 relative settings-main">
                {children}
            </div>
        </>
    );
}
